


















import Vue from "vue";
import { Component, Watch } from "vue-property-decorator";
import { Action, State } from "vuex-class";
import { SuccessMessage } from "@/shared";

@Component
export default class AppNotifications extends Vue {
  @Action("showMessage", { namespace: "notification" }) showMessage: any;
  @State("message", { namespace: "notification" }) message: any;
  @State("type", { namespace: "notification" }) type: any;

  show = false;

  @Watch("show")
  onShowChanged(val: boolean, oldVal: boolean) {
    if (!this.show) {
      //reset message state when done showing existing message
      this.showMessage(new SuccessMessage(""));
    }
  }

  @Watch("message")
  onMessageChanged(val: string, oldVal: string) {
    if (val) this.show = true;
  }
}
